import Vue from 'vue'
import Router from 'vue-router'
// 首页
import Index from '../pages/home/Index.vue'
// 课程详细页
import ClassDetial from '../pages/class/ClassDetial.vue'
import CourseCatalogue from '../pages/class/CourseCatalogue.vue'
import Speaker from '../pages/class/Speaker.vue'
import CourseIntroduction from '../pages/class/CourseIntroduction.vue'
import CurriculumEvaluation from '../pages/class/CurriculumEvaluation.vue'
import SubmitSuccess from '../pages/class/SubmitSuccess.vue'
import PlayVideo from '../pages/class/PlayVideo.vue'
// 搜索
import Search from '../pages/search/Search.vue'
// 平台介绍
import PlatformIntroduction from '../pages/PlatformIntroduction'
// 个人中心
import PersonalCenter from '../pages/PersonalCenter/PersonalIndex.vue'
import MyCourse from '../pages/PersonalCenter/MyCourse.vue'
import LearnCount from '../pages/PersonalCenter/LearnCount.vue'
import MyCollection from '../pages/PersonalCenter/MyCollection.vue'
// 管理中心
import ManagementIndex from '../pages/ManagementCenter/ManagementIndex.vue'
import ClassHourManagement from '../pages/ManagementCenter/ClassHourManagement.vue'
import CreditManagement from '../pages/ManagementCenter/CreditManagement.vue'
import CourseManagement from '../pages/ManagementCenter/CourseManagement.vue'
// 联系我们
import ContactUs from '../pages/ContactUs'
// 功能建设中
import TobeDeveloped from '../pages/TobeDeveloped'

Vue.use(Router)

const router = new Router({
	// mode: 'history',  // 去掉#
	routes: [{
			path: '/',
			redirect: 'index',
			meta: {
				title: '课程中心'
			}
		},
		{
			path: '/index',
			name: 'Index',
			component: Index,
			meta: {
				title: '课程中心'
			},
			beforeEnter: (to, from, next) => {
				let url = sessionStorage.getItem('YunToUrl');
				if (url) {
					sessionStorage.removeItem('YunToUrl');
					next();
					location.href = url;
					return;
				}
				next();
			}
		},
		{
			path: '/search',
			name: 'Search',
			component: Search,
			meta: {
				title: '搜索'
			}
		},
		{
			path: '/contactUs',
			name: 'ContactUs',
			component: ContactUs,
			meta: {
				title: '联系我们'
			}
		},
		{
			path: '/tobeDeveloped',
			name: 'TobeDeveloped',
			component: TobeDeveloped,
			meta: {
				title: '学技强隧'
			}
		},
		{
			path: '/platformIntroduction',
			name: 'PlatformIntroduction',
			component: PlatformIntroduction,
			meta: {
				title: '平台介绍'
			}
		},
		{
			path: '/classDetial',
			name: 'ClassDetial',
			component: ClassDetial,
			children: [{
					path: 'courseCatalogue',
					name: 'CourseCatalogue',
					component: CourseCatalogue
				},
				{
					path: 'speaker/:id',
					name: 'Speaker',
					component: Speaker
				},
				{
					path: 'courseIntroduction',
					name: 'CourseIntroduction',
					component: CourseIntroduction
				},
			],
			redirect: '/classDetial/courseCatalogue'
		},
		{
			path: '/curriculumEvaluation',
			name: 'CurriculumEvaluation',
			component: CurriculumEvaluation,
			meta: {
				title: '课程评价'
			}
		},
		{
			path: '/submitSuccess',
			name: 'SubmitSuccess',
			component: SubmitSuccess,
			meta: {
				title: '提交成功'
			}
		},
		{
			path: '/playVideo',
			name: 'PlayVideo',
			component: PlayVideo,
			meta: {
				title: '播放视频'
			}
		},
		{
			path: '/personalCenter',
			name: 'PersonalCenter',
			component: PersonalCenter,
			children: [{
					path: 'myCourse',
					name: 'MyCourse',
					component: MyCourse,
					meta: {
						title: '我的课程_学员中心'
					}
				},
				{
					path: 'learnCount',
					name: 'LearnCount',
					component: LearnCount,
					meta: {
						title: '学习统计_学员中心'
					}
				},
				{
					path: 'myCollection',
					name: 'MyCollection',
					component: MyCollection,
					meta: {
						title: '我的收藏_学员中心'
					}
				},
			],
			redirect: '/personalCenter/myCourse'
		},
		{
			path: '/managementIndex',
			name: 'ManagementIndex',
			component: ManagementIndex,
			children: [{
					path: 'classHourManagement',
					name: 'ClassHourManagement',
					component: ClassHourManagement,
					meta: {
						title: '学时管理_管理中心'
					}
				},
				{
					path: 'creditManagement',
					name: 'CreditManagement',
					component: CreditManagement,
					meta: {
						title: '学分管理_管理中心'
					}
				},
				{
					path: 'courseManagement',
					name: 'CourseManagement',
					component: CourseManagement,
					meta: {
						title: '课程管理_管理中心'
					}
				}
			],
			redirect: '/managementIndex/classHourManagement'
		}
	]
});
// 全局路由守卫
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title + '_云课堂';
	}
	next()
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js